import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { BodyText, theme } from '@sg/garnish';

export const OrderStatusLineItemGroupHeader = (props: Props) => {
  const { participantName, isCurrentUser } = props;

  const { formatMessage } = useIntl();

  // ─── Derived ──────────────────────────────────────────────────────────────

  const displayName = participantName || formatMessage(messages.guest);

  // ─────────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      <BodyText accessibilityRole="header" sizeMatch={['16']}>
        {isCurrentUser ? (
          <FormattedMessage {...messages.yourOrder} />
        ) : (
          <FormattedMessage
            {...messages.participantOrder}
            values={{ participant_name: displayName }}
          />
        )}
      </BodyText>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  guest: {
    defaultMessage: 'Guest',
    description: 'Order Status | Group order | Participant fallback name',
  },
  participantOrder: {
    defaultMessage: '{participant_name}’s order',
    description: 'Order Status | Group order | Participant line items heading',
  },
  yourOrder: {
    defaultMessage: 'Your order',
    description: 'Order Status | Group order | Current participant line items heading',
  },
});

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    borderBottomColor: theme.colors.LIGHT,
    borderBottomWidth: 1,
    paddingTop: theme.spacing['3'],
    paddingBottom: theme.spacing['2'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  participantName?: string | null;
  isCurrentUser: boolean;
};
